import React from 'react';
import PropTypes from 'prop-types';
import classNames from "classnames";
import { Disclosure } from "@headlessui/react";
import { ChevronRightIcon } from "@heroicons/react/solid";

export default class PropertyPanel extends React.Component
{
    static propTypes = {
        title: PropTypes.string.isRequired,
        defaultOpen: PropTypes.bool
    };

    static defaultProps = {
        defaultOpen: false
    };

    render()
    {
        const { title, defaultOpen, className, children } = this.props;

        const classes = {
            button: classNames(
                "flex items-center justify-between w-full px-4 py-2",
                "text-xs font-medium text-left text-black uppercase",
                "bg-gray-100 hover:bg-gray-200 focus:bg-gray-200 focus:outline-none",
                "focus-visible:bg-gray-200",
            ),
            icon: open => classNames(
                "w-5 h-5",
                {
                    "transform rotate-90": open,
                }
            ),
            panel: classNames(
                className,
                "p-4 text-sm text-gray-500"
            )
        };

        return <Disclosure defaultOpen={defaultOpen}>
            {({ open }) => {
                return <div>
                    <Disclosure.Button className={classes.button}>
                        <span>{ title }</span>
                        <ChevronRightIcon className={classes.icon(open)}/>
                    </Disclosure.Button>
                    {
                        open && (
                            <Disclosure.Panel className={classes.panel} static>
                                { children }
                            </Disclosure.Panel>
                        )
                    }
                </div>
            }}
        </Disclosure>;
    }
}
